// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAiKeMtndXjfkoW0MG4rzBnCwRJx7wyAPo",
  authDomain: "restaurant-spicy-kitchen.firebaseapp.com",
  databaseURL: "https://restaurant-spicy-kitchen-default-rtdb.firebaseio.com",
  projectId: "restaurant-spicy-kitchen",
  storageBucket: "restaurant-spicy-kitchen.appspot.com",
  messagingSenderId: "1051758614428",
  appId: "1:1051758614428:web:f3e8c5f3db54d79ab6da59"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const database = getDatabase(app);